// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Forbidden!',
  text: `Some specific key was missing to access that resource. If you need any tools that you do not currently have
  access to, please talk to an administrator.`,
  btn: {
    text: 'How about going back home?',
    title: 'click here to return to the home page',
  },
} as ILanguage;
